import { render, staticRenderFns } from "./colorTest.vue?vue&type=template&id=47a3cd32"
import script from "./colorTest.vue?vue&type=script&lang=js"
export * from "./colorTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports